module.exports = __webpack_public_path__ + "img/file-diff.68886d27.svg";